import React from 'react'

import { SpaceProps } from './Space.model'
import { StyledSpace } from './Space.styled'

export const Space = ({ inline, margin, padding, space }: SpaceProps) => (
  <StyledSpace
    inline={inline}
    margin={margin}
    padding={padding}
    space={space}
  />
)

export default Space
